var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 sm:px-6 py-5 space-y-8"},[_c('TrackingLogList',{attrs:{"email-campaign":_vm.emailCampaign,"default-query-params":_vm.options.defaultQueryParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }